import firebase from "firebase";

var firebaseConfig = {
    apiKey: "AIzaSyCSy2wf4Ox56_e_S50S5PBqS2usJBI8md0",
    authDomain: "flatsdatabase-dbcf5.firebaseapp.com",
    databaseURL: "https://flatsdatabase-dbcf5.firebaseio.com",
    projectId: "flatsdatabase-dbcf5",
    storageBucket: "flatsdatabase-dbcf5.appspot.com",
    messagingSenderId: "464067320371",
    appId: "1:464067320371:web:57e3c8a3d02f93b8a32146",
    measurementId: "G-Q20LS66LJ7",

};
const fire = firebase.initializeApp(firebaseConfig);
export default fire;
